import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import IconButton from '../../../../../icon-button';
import { TreeViewActionType } from '../../../../constants/types';

const isMobile = bowser.mobile;

const TreeViewItemActions = ({ actions, disabled = false }) => (
  <div className="ws-ui-tree-view-item-actions">
    {actions.map(({ onClick, label, glyph }) => {
      const handleClick = (event) => {
        event.stopPropagation();
        onClick();
      };

      return (
        <div className="ws-ui-tree-view-item-actions__action" key={label}>
          <IconButton
            appearance="accent"
            size={isMobile ? 'medium' : 'small'}
            disabled={disabled}
            label={label}
            glyph={glyph}
            onClick={handleClick}
          />
        </div>
      );
    })}
  </div>
);

TreeViewItemActions.propTypes = {
  actions: PropTypes.arrayOf(TreeViewActionType).isRequired,
  disabled: PropTypes.bool,
};

export default TreeViewItemActions;
